package com.tovtalk.ui.screen.splash

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.tovtalk.utils.config.isWeb

@Composable
fun UpdateRequiredScreen(
    storeUrlAndroid: String?,
    storeUrlIos: String?,
    webUpdateInstructions: String?,
    onOpenUrl: (String) -> Unit,
) {
    val isWeb = isWeb()
    val storeUrl = when {
        isWeb -> null
        else -> storeUrlAndroid ?: storeUrlIos
    }
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(24.dp),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Text(
            text = "נדרש עדכון",
            style = MaterialTheme.typography.headlineMedium,
            textAlign = TextAlign.Center,
        )
        Spacer(modifier = Modifier.height(16.dp))
        if (isWeb && !webUpdateInstructions.isNullOrBlank()) {
            Text(
                text = webUpdateInstructions,
                style = MaterialTheme.typography.bodyLarge,
                textAlign = TextAlign.Center,
            )
        } else if (!storeUrl.isNullOrBlank()) {
            Text(
                text = "יש לעדכן את האפליקציה לגרסה חדשה.",
                style = MaterialTheme.typography.bodyLarge,
                textAlign = TextAlign.Center,
            )
            Spacer(modifier = Modifier.height(24.dp))
            Button(onClick = { onOpenUrl(storeUrl) }) {
                Text("עדכן עכשיו")
            }
        } else {
            Text(
                text = "יש לעדכן את האפליקציה לגרסה חדשה.",
                style = MaterialTheme.typography.bodyLarge,
                textAlign = TextAlign.Center,
            )
        }
    }
}
